function Footer() {
  return (
    <footer className="App-Footer">
      👉 Follow me on LinkedIn:&nbsp;
      <a
        target="_blank"
        href="https://www.linkedin.com/in/theprogrammer/"
        style={{ color: "#d5c3f4" }}
      >
        Krishna Paul
      </a>
    </footer>
  );
}

export default Footer;
